import { render, staticRenderFns } from "./SubscriptionMassFormScreen.vue?vue&type=template&id=779e88ea&"
import script from "./SubscriptionMassFormScreen.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionMassFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports